import { PillButton, SectionBadge } from "./SitePrimitives";

/** "Available when you need us" estimate box; like Framer, its button leads to the contact page. */
export function SiteContact({
  badge,
  title,
  description,
  ctaLabel,
  href,
  onCta,
}: {
  badge?: string;
  title: string;
  description: string;
  ctaLabel: string;
  href: string;
  onCta?: () => void;
}) {
  return (
    <section id="estimate" className="px-4 pt-[132px] min-[810px]:px-0 min-[810px]:pt-[97px] min-[1200px]:pt-[119px]">
      <div className="min-[810px]:mx-auto min-[810px]:max-w-[1264px] min-[810px]:px-8 min-[1200px]:max-w-[1200px] min-[1200px]:px-0">
        <div className="relative overflow-hidden rounded-2xl bg-[#0E2827] px-8 py-[100px] min-[810px]:rounded-3xl min-[810px]:max-[1199px]:py-[39px]">
          <img
            src="/site/cta-watermark.svg"
            alt=""
            className="pointer-events-none absolute left-[-74px] top-[137px] h-[470px] w-[1723px] max-w-none min-[810px]:left-[-95px] min-[810px]:top-[-69px] min-[810px]:h-[601px] min-[810px]:w-[2201px] min-[1200px]:left-[-135px] min-[1200px]:top-[-78px] min-[1200px]:h-[700px] min-[1200px]:w-[2565px]"
          />
          <div className="relative mx-auto flex max-w-[600px] flex-col items-center text-center min-[810px]:max-[1199px]:max-w-[680px]">
            <SectionBadge>{badge}</SectionBadge>
            <h2 className="site-h2 mt-[11px] text-white">{title}</h2>
            {description ? <p className="site-lead mt-4">{description}</p> : null}
            {ctaLabel ? (
              <PillButton href={href} className="mt-8" onClick={onCta}>
                {ctaLabel}
              </PillButton>
            ) : null}
          </div>
        </div>
      </div>
    </section>
  );
}
